import { Box, Stack } from '@mantine/core'
import Notifications from '../../components/dashboard/Notifications'

// Notifications page component
const NotificationsPage = () => {
  return (
    <Box style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Stack style={{ flex: 1, overflow: 'hidden' }}>
        <Notifications />
      </Stack>
    </Box>
  )
}

export default NotificationsPage
